import React from 'react'
import styles from './cell.styles'
import injectSheet from 'react-jss'
import classNames from 'classnames'

const Cell = ({ classes, children, className }) => (
  <div className={classNames(classes.cell, className)}>{children}</div>
)

export default injectSheet(styles)(Cell)
